import useCountUp from '../hooks/useCountUp';

// Sayısal değeri count-up animasyonuyla gösterir.
export default function CountUp({ value, decimals = 0, duration = 900, suffix = '', prefix = '' }) {
  const n = useCountUp(value, { duration, decimals });
  const formatted = n.toLocaleString('tr-TR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return (
    <span>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
}
